module.exports = __webpack_public_path__ + "img/drug-32.96057dd0.png";